import React from "react";
import styles from "./css/AICourseBanner.module.css";

export default function AICourseBanner({ onClick }) {
  return (
    <div className={styles.banner} role="button" onClick={onClick}>
      <div className={styles.left}>
        <div className={styles.iconWrapper}>
          <img src="/Image/sparkle.svg" alt="AI Course Icon" className={styles.icon} />
        </div>

        <div className={styles.text}>
          <div className={styles.titleRow}>
            <span className={styles.title}>AI Course Generator</span>
            <span className={styles.badge}>NEW</span>
          </div>
          <span className={styles.subtitle}>
            Click here to create custom courses instantly with AI - just enter your course idea and upload curriculum files
          </span>
        </div>
      </div>

      <div className={styles.arrow}><img src="/Image/arrow.svg" alt="Arrow" /></div>
    </div>
  );
}
